const buttonClasses = 'bg-white text-primary-600';

const buttonHoverClasses = 'hover:bg-neutrals-300';

const buttonIconClasses = 'fill-primary-600';

const buttonWhiteClasses = { buttonBlogVariantClasses: [buttonClasses, buttonHoverClasses], buttonIconClasses };

export default buttonWhiteClasses;
